/**
 * Created by yuning.jin on 16/12/22.
 */

var apiserver = Global_apiserver;

/*
 toolslist 化疗手册列表
 */

exports.api = {

    /**
     * 6.2 alai 添加
     * 微信统一下单接口
     *
     */
    webPay: {
        apiurl: apiserver + "/api/wxpay/webPay",
        postData: {
            head: {
                auth: "",
                cid: "hotel-california",
                cver: "6.2"
            },
            appId: Global_appid,
            attach: "",
            body: "",
            openId: "",
            outTradeNo: "",
            totalFee: 0
        }
    },

    /**
     * 6.0 开发 添加医生功能 拉取预注册信息接口
     * https://rap.liangyihui.net/repository/editor?id=17&mod=49&itf=201
     */
    userPreRegInfo: {
        apiurl: apiserver + "/api/user/userPreRegInfo",
        postData: {
            head: {
                cid: "hotel-california",
                cver: "5.2",
                sid: "A",
                extensions: [{
                    name: "A",
                    value: "A"
                }],
                auth: "",
                auth2: ""
            },
            preId: 0,
            openId: ""

        }
    },

    /**
     * 6.0 开发 添加医生功能 关联用户接口
     * https://rap.liangyihui.net/repository/editor?id=17&mod=49&itf=202
     */
    userAcceptEtpApply: {
        apiurl: apiserver + "/api/user/userAcceptEtpApply",
        postData: {
            head: {
                cid: "hotel-california",
                cver: "5.2",
                sid: "A",
                extensions: [{
                    name: "A",
                    value: "A"
                }],
                auth: "",
                auth2: ""
            },
            preId: 0,
            thirdPartyAuth: "",
            mobile: "",
            verifyCode: "",
            isBindWeChat: 0
        }
    },

    wxOpenId: {
        apiurl: Global_root_path + "doctor/tp/Index/openid",
        postData: {
            code: "",
            state: "",
            head: {
                auth: "",
                auth2: ""
            }
        }
    },
    wxUnionId: {
        apiurl: Global_root_path + "doctor/tp/Index/getUnionid",
        postData: {
            code: "",
            state: "",
            head: {
                auth: "",
                auth2: ""
            }
        }
    },

    livesinfo: {
        apiurl: apiserver + "/api/doc/sharelivedetail?id=ID"
    },
    wxsearch: {
        apiurl: apiserver + "/api/pub/search",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "E501D04B-AAE3-4311-8807-A029098084D0",
                cver: "2.3",
                sid: "Model:iPod touch---Version:10.2",
                patientToken: ""
            },
            filter: {
                keywords: {
                    keyword: "",
                    keywordType: 0
                },
                pageSize: 3,
                pageIdx: 0
            },
            userType: 1,
            resultType: 128
        }
    },
    toolslist: {
        apiurl: apiserver + "/api/tools/getlist",
        postData: {
            sort: {
                pageIdx: 0,
                pageSize: 500,
                startTime: 1459144225
            },
            head: {
                auth: ""
            },
            //1 化疗手册
            type: 1,
            //0 按拼音，1 更新时间排序
            order: 0,
            parentId: 0
        }
    },
    organizationdetail: {
        apiurl: apiserver + "/api/org/getorganizationdetail",
        postData: {
            head: {
                patientToken: ""
            },
            actionType: 0,
            orgId: 0
        }
    },
    organizationlist: {
        apiurl: apiserver + "/api/org/getorganizationlist",
        postData: {
            sort: {
                pageIdx: 0,
                pageSize: 500,
                startTime: 1459144225
            },
            head: {
                patientToken: ""
            },
            actionType: 0,
            orgId: 0
        }
    },
    doclist: {
        apiurl: apiserver + "/api/org/getdoclist",
        postData: {
            sort: {
                pageIdx: 0,
                pageSize: 500,
                startTime: 1459144225
            },
            head: {
                patientToken: ""
            },
            orgId: 0
        }
    },
    // 从这里开始
    // 本周最热
    gettoplist: {
        apiurl: apiserver + "/api/doc/gettoplist",
        postData: {

            filter: {
                startTime: 0,
                endTime: 0,
                pageIdx: 0,
                pageSize: 20
            },
            period: 0,
            head: {
                cid: "19364DBE-FA96-4801-9B23-09C4F9788F7B",
                cver: "5.2",
                sid: "Model:iPhone---Version:10.1",
                extensions: [{
                    name: "platform",
                    value: "iOS"
                }],
                auth: "",
                auth2: "YMp/hofsLd4lODcEb2xG6g=="
            }
        }
    },
    gettoplistWX: {
        apiurl: apiserver+"/api/doc/gettoplist",
        postData: {
            type:1,
            filter: {
                startTime: 0,
                endTime: 0,
                pageIdx: 0,
                pageSize: 10
            },
            period: 0,
            head: {
                cid: "19364DBE-FA96-4801-9B23-09C4F9788F7B",
                cver: "5.2",
                sid: "Model:iPhone---Version:10.1",
                extensions: [{
                    name: "platform",
                    value: "iOS"
                }],
                auth: "",
                auth2: "YMp/hofsLd4lODcEb2xG6g=="
            }
        }
    },
    //搜索结果
    getSearchResult: {
        apiurl: apiserver + "/api/pub/search",
        postData: {
            filter: {
                keywords: {
                    keyword: "肺癌",
                    keywordType: 0
                },
                pageIdx: 0,
                pageSize: 10
            },
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "9.5.7",
                extensions: []
            },
            path: "/api/pub/search",
            resultType: 7,
            userType: 1
        }
    },
    //区块
    getSections: {
        apiurl: apiserver + "/api/doc/getfuncblocklist",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/doc/getfuncblocklist",
            sort: {
                pageIdx: 0,
                pageSize: 3,
                startTime: 0
            }
        }
    },
    // 没有调用
    getKnowledgeTypes: {
        apiurl: apiserver + "/api/pub/getstaticdata",
        postData: {
            dataforItems: [{
                dataforId: 18,
                version: 3.3
            }],
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/pub/getstaticdata"
        }
    },
    // 专家和专题的详情要用
    getBannerData: {
        apiurl: apiserver + "/api/pub/getadvertise",
        postData: {
            hardware: {
                height: 2560,
                width: 1440
            },
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: [{
                        name: "platform",
                        value: "Android"
                    },
                    {
                        name: "channel",
                        value: "liangyihui"
                    },
                    {
                        name: "networkType",
                        value: "WIFI"
                    },
                    {
                        name: "phoneType",
                        value: "SM-N9108V"
                    },
                    {
                        name: "phoneVersion",
                        value: "6.0.1"
                    }
                ]
            },
            path: "/api/pub/getadvertise"
        }
    },
    // 公开课列表
    getClassList: {
        apiurl: apiserver + "/api/doc/getdocumentlist",
        postData: {
            filters: [{
                filterGroupId: 1,
                items: [{
                    filterId: 8,
                    type: 1
                }]
            }],
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/doc/getdocumentlist",
            sort: {
                pageIdx: 0,
                pageSize: 25,
                startTime: 0
            }
        }
    },
    getMySub: {
        apiurl: apiserver + "/api/doc/getdocumentlist",
        postData: {
            filters: [{
                filterGroupId: 1,
                items: [{
                    filterId: 3,
                    type: 1
                }]
            }],
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/doc/getdocumentlist",
            sort: {
                pageIdx: 0,
                pageSize: 10,
                startTime: 0
            }
        }
    },
    getCaseList: {
        apiurl: apiserver + "/api/doc/getdocumentlist",
        postData: {
            filters: [{
                filterGroupId: 1,
                items: [{
                    filterId: 10,
                    type: 1
                }]
            }],
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.2",
                extensions: []
            },
            path: "/api/doc/getdocumentlist",
            sort: {
                pageIdx: 0,
                pageSize: 10,
                startTime: 0
            }
        }
    },
    // 最新资讯
    getNews: {
        apiurl: apiserver + "/api/doc/getdocumentlist",
        postData: {
            filters: [{
                filterGroupId: 1,
                items: [{
                    filterId: 1,
                    type: 1
                }]
            }],
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/doc/getdocumentlist",
            sort: {
                pageIdx: 0,
                pageSize: 15,
                startTime: 0
            }
        }
    },
    // 公开课列表 直播2预告
    getPreList: {
        apiurl: apiserver + "/api/doc/getprevuecount",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/doc/getprevuecount"
        }
    },
    getKnowledgeDetailChannels: {
        apiurl: apiserver + "/api/pub/getchannelhierarchy",
        postData: function(id) {
            return {
                head: {
                    auth: "",
                    auth2: "",
                    cid: "354782065344066",
                    cver: "8.3",
                    extensions: []
                },
                path: "/api/pub/getchannelhierarchy",
                root: id
            };
        }
    },
    getKnowledgeChannels: {
        apiurl: apiserver + "/api/pub/getstaticdata",
        postData: {
            dataforItems: [{
                dataforId: 18,
                version: 3.3
            }],
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/pub/getstaticdata"
        }
    },
    // 病例
    getChannels1: {
        apiurl: apiserver + "/api/pub/getstaticdata",
        postData: {
            dataforItems: [{
                dataforId: 1,
                version: 3.3
            }],
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/pub/getstaticdata"
        }
    },
    getKnowledgeList: {
        apiurl: apiserver + "/api/doc/getdocumentlist",
        postData: function(filterArray, currentPage) {
            return {
                filters: [{
                    filterGroupId: 17,
                    items: filterArray
                }],
                head: {
                    auth: "",
                    auth2: "",
                    cid: "354782065344066",
                    cver: "8.3",
                    extensions: []
                },
                path: "/api/doc/getdocumentlist",
                sort: {
                    pageIdx: currentPage - 1,
                    pageSize: 10,
                    startTime: 0
                }
            };
        }
    },
    getColumnList: {
        apiurl: apiserver + "api/pub/getcolumnist",
        postData: {
            filter: {
                pageIdx: 0,
                pageSize: 100
            },
            actionType: 0,
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            }
        }
    },
    getColumnMainList: {
        apiurl: apiserver + "api/pub/getcolumnist",
        postData: function(pageIdx) {
            return {
                filter: {
                    pageIdx: pageIdx - 1,
                    pageSize: 100
                },
                actionType: 2,
                head: {
                    auth: "",
                    auth2: "",
                    cid: "354782065344066",
                    cver: "8.3",
                    extensions: []
                }
            };
        }
    },
    getcolumnistdetail: {
        apiurl: apiserver + "api/pub/getcolumnistdetail",
        postData: function(columnistId) {
            return {
                columnistId: columnistId,
                head: {
                    auth: "",
                    auth2: "",
                    cid: "354782065344066",
                    cver: "8.3",
                    extensions: []
                }
            };
        }
    },
    // 患者招募
    getPatientRecruitment: {
        apiurl: apiserver + "api/doc/getdocumentlist",
        postData: function(filterid, currentPage) {
            return {
                filters: [{
                    filterGroupId: 1,
                    items: [{
                        filterId: filterid,
                        type: 1
                    }],
                    name: "临床试验招募"
                }],
                head: {
                    auth: "",
                    auth2: "",
                    cid: "354782065344066",
                    cver: "8.3",
                    extensions: []
                },
                sort: {
                    pageIdx: currentPage - 1,
                    pageSize: 10,
                    startTime: 0
                }
            };
        }
    },
    getPatientFilter: {
        apiurl: apiserver + "api/pub/getstaticdata",
        postData: {
            dataforItems: [{
                dataforId: 8,
                version: 3.0
            }],
            head: {
                auth: "",
                auth2: "",
                cid: "99000536375861",
                cver: "3.0.3",
                extensions: []
            }
        }
    },
    getDocumentDetail: {
        apiurl: apiserver + "/api/doc/getdocumentdetail",
        postData: function(docId) {
            return {
                head: {
                    auth: "",
                    auth2: "",
                    cid: "354782065344066",
                    cver: "8.3",
                    extensions: []
                },
                docId: docId
            };
        }
    },
    // queryType 1 普通评论 2 热门评论 3 专家评论
    getComment: {
        apiurl: apiserver + "/api/comment/commentlist",
        postData: function(docId, queryType) {
            return {
                head: {
                    auth: "",
                    auth2: "",
                    cid: "354782065344066",
                    cver: "8.3",
                    extensions: []
                },
                docId: docId,
                listType: 1,
                commentFilter: {
                    queryType: queryType,
                    pageIdx: 0,
                    pageSize: 25
                }
            };
        }
    },
    getRelated: {
        apiurl: apiserver + "/api/doc/relatedreading",
        postData: function(docId) {
            return {
                head: {
                    auth: "",
                    auth2: "",
                    cid: "354782065344066",
                    cver: "8.3",
                    extensions: []
                },
                docID: docId
            };
        }
    },
    getSpecialDetail: {
        apiurl: apiserver + "api/org/getdiagnosisspecialistdetail",
        postData: function(userId) {
            return {
                specialistId: userId,
                columnistDocLength: 5,
                head: {
                    auth: "",
                    auth2: "",
                    cid: "354782065344066",
                    cver: "8.3",
                    extensions: []
                }
            };
        }
    },

    getFilterData: {
        apiurl: apiserver + "api/org/getfilterdata",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            }
        }
    },

    getCancerDoctors: {
        apiurl: apiserver + "api/org/getdiagnosisspecialists",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "a000005921fc37",
                cver: "8.3",
                sid: "",
                extensions: [],
                patientToken: ""
            },
            sort: {
                pageSize: 500,
                pageIdx: 0
            },
            cancerType: "",
            area: "",
            hospital: "",
            department: ""
        }
    },

    //
    getConsulationDetail: {
        apiurl: apiserver + "api/org/getdiagnosismaininfo",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "a000005921fc37",
                cver: "8.3",
                sid: null,
                extensions: [],
                patientToken: ""
            },
            specialistLength: 0
        }
    },
    getColumnDetail: {
        apiurl: apiserver + "api/org/getdiagnosismaininfo",
        postData: function(columnId) {
            return {
                head: {
                    auth: "",
                    auth2: "",
                    cid: "a000005921fc37",
                    cver: "8.3",
                    sid: null,
                    extensions: [],
                    patientToken: ""
                },
                columnistId: columnId
            };
        }
    },

    // banner?
    getBannerData: {
        apiurl: apiserver + "api/pub/getadvertise",
        postData: {
            actionType: 1,
            hardware: {
                height: 2560,
                width: 1440
            },
            head: {
                auth: "",
                auth2: "IOM2uSpF7agYcO15DbhX0w==",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/pub/getadvertise"
        }
    },

    getLiveCast: {
        apiurl: apiserver + "api/doc/livemessage",
        postData: function(docId) {
            return {
                head: {
                    auth: "",
                    auth2: "IOM2uSpF7agYcO15DbhX0w==",
                    cid: "354782065344066",
                    cver: "8.3",
                    extensions: []
                },
                docId: docId,
                filter: {
                    pageIdx: 0,
                    pageSize: 500
                }
            };
        }
    },
    getLiveList: {
        apiurl: apiserver + "api/doc/getdocumentlist",
        postData: {
            filters: [{
                filterGroupId: 1,
                items: [{
                    filterId: 8,
                    type: 1
                }]
            }],
            head: {
                auth: "",
                auth2: "",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/doc/getdocumentlist",
            sort: {
                pageIdx: 0,
                pageSize: 10,
                startTime: 0
            }
        }
    },
    getColumnDocList: {
        apiurl: apiserver + "api/doc/getdocumentlist",
        postData: function(filterId) {
            return {
                filters: [{
                    filterGroupId: 5,
                    items: [{
                        filterId: filterId,
                        type: 1
                    }]
                }],
                head: {
                    auth: "",
                    auth2: "",
                    cid: "",
                    cver: "8.3",
                    sid: null,
                    extensions: [],
                    patientToken: ""
                },
                sort: {
                    pageIdx: 0,
                    pageSize: 200,
                    startTime: 1482832405
                }
            };
        }
    },
    getColumnBannerData: {
        apiurl: "http://web.liangyihui.net/tools/getsavekey",
        postData: function(filterId) {
            return {
                savekey: "h5_spsubject_banner_id_" + filterId,
                type: "json"
            };
        }
    },
    getSubjectDetail: {
        apiurl: apiserver + "api/doc/geteventinfo",
        postData: function(eventId) {
            return {
                head: {
                    auth: "",
                    auth2: "",
                    cid: "a000005921fc37",
                    cver: "8.3",
                    sid: null,
                    extensions: [],
                    patientToken: ""
                },
                eventId: eventId
            };
        }
    },
    getSubjectDocList: {
        apiurl: apiserver + "api/doc/getdocumentlist",
        postData: function(filterId) {
            return {
                filters: [{
                    filterGroupId: 4,
                    items: [{}]
                }],
                eventId: filterId,
                head: {
                    auth: "",
                    auth2: "",
                    cid: "a000005921fc37",
                    cver: "8.3",
                    sid: null,
                    extensions: [],
                    patientToken: ""
                },
                sort: {
                    pageIdx: 0,
                    pageSize: 200,
                    startTime: 0
                }
            };
        }
    },
    // 轮播图
    getCarousel: {
        apiurl: apiserver + "api/pub/getadvertise",
        postData: {
            actionType: 0,
            hardware: {
                height: 2560,
                width: 1440
            },
            head: {
                auth: "",
                auth2: "IOM2uSpF7agYcO15DbhX0w==",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/pub/getadvertise"
        }
    },
    getnewCarousel: {
        apiurl: apiserver + "api/pub/getadvertise",
        postData: {
            actionType: 9,
            hardware: {
                height: 2560,
                width: 1440
            },
            head: {
                auth: "",
                auth2: "IOM2uSpF7agYcO15DbhX0w==",
                cid: "354782065344066",
                cver: "8.3",
                extensions: []
            },
            path: "/api/pub/getadvertise"
        }
    },
    getOneDayHot: {
        apiurl: apiserver + "/api/doc/gettoplist",
        postData: {
            filter: {
                pageSize: 10,
                pageIdx: 0
            },
            period: 86400,
            head: {
                cid: "19364DBE-FA96-4801-9B23-09C4F9788F7B",
                cver: "2.2",
                sid: "Model:iPhone---Version:10.1",
                extensions: [{
                    name: "platform",
                    value: "iOS"
                }],
                auth: "",
                auth2: "YMp/hofsLd4lODcEb2xG6g=="
            }
        }
    },
    getChannels: {
        apiurl: apiserver + "/api/pub/getuserconfig",
        postData: {
            head: {
                cid: "19364DBE-FA96-4801-9B23-09C4F9788F7B",
                cver: "3.0",
                sid: "Model:iPhone---Version:10.1",
                extensions: [{
                    name: "platform",
                    value: "iOS"
                }],
                auth: "",
                auth2: "YMp/hofsLd4lODcEb2xG6g=="
            },
            actionType: 1
        }
    },
    getInterestDiseases: {
      apiurl: apiserver + "/api/disease/interestDiseases",
      postData: {
        head: {
          cid: "19364DBE-FA96-4801-9B23-09C4F9788F7B",
          cver: "3.0",
          sid: "Model:iPhone---Version:10.1",
          extensions: [{
            name: "platform",
            value: "iOS"
          }],
          auth: "",
          auth2: "YMp/hofsLd4lODcEb2xG6g=="
        },
        actionType: 1
      }
    },
    choseMyInterestDisease: {
        apiurl: apiserver + "/api/disease/choseMyInterestDisease",
        postData: {
          head: {
            cid: "19364DBE-FA96-4801-9B23-09C4F9788F7B",
            cver: "3.0",
            sid: "Model:iPhone---Version:10.1",
            extensions: [{
              name: "platform",
              value: "iOS"
            }],
            auth: "",
            auth2: "YMp/hofsLd4lODcEb2xG6g=="
          },
          actionType: 1
        }
    },
    getSubjectList: {
        apiurl: apiserver + "/api/doc/getdocumentlist",
        postData: function(filterId) {
            return {
                filters: [{
                    filterGroupId: 1,
                    items: [{
                        filterId: filterId,
                        type: 1
                    }]
                }],
                head: {
                    auth: "",
                    auth2: "",
                    cid: "354782065344066",
                    cver: "8.3",
                    extensions: []
                },
                path: "/api/doc/getdocumentlist",
                sort: {
                    pageIdx: 0,
                    pageSize: 15,
                    startTime: 0
                }
            };
        }
    },
    loginuser: {
        apiurl: apiserver + "/api/user/loginuser",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: ""
            },
            mobile: "",
            password: ""
        }
    },
    quickLogin: {
        apiurl: apiserver + "/api/user/registeruser",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.4"
            },
            mobile: "",
            actionType: 5,
            verifyCode: 793736
        }
    },
    /*api/user/registeruser
       设置[V1.0]1:注册：新用户注册
       2:新设置密码：忘记密码，发送验证码设置新密码
       3:修改密码：有旧的密码，需要变更密码
       4:验证注册码是否正确
       5:快速登录
       6:企业版员工登录
       [v2.0]7:企业版审核时注册
       [v2.0.2]8:微信与新注册用户绑定
       [v2.0.2]9:微信与已存在用户绑定*/
    resetPassword: {
        apiurl: apiserver + "/api/user/registeruser",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.4"
            },
            mobile: "",
            passwordNew: "",
            actionType: 2,
            verifyCode: 793736
        }
    },
    reg: {
        apiurl: apiserver + "/api/user/registeruser",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.4"
            },
            mobile: "",
            passwordNew: "",
            actionType: 1,
            verifyCode: 793736
        }
    },
    choicerole: {
        apiurl: apiserver + "/api/user/choicerole",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.4"
            },
            roleType: 0
        }
    },
    getuserinfo: {
        apiurl: apiserver + "/api/user/getuserinfo",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "7.1"
            }
        }
    },
    silencelogin: {
        apiurl: apiserver + "/api/user/silencelogin",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.4"
            }
        }
    },
    setuserinfo: {
        apiurl: apiserver + "/api/user/setuserinfo",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.4"
            },
            userType: "0"
        }
    },
    getqiniuToken: {
        apiurl: apiserver + "/api/pub/getqiniuuploadtoken",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.4"
            },
            // type 2 Certification:data ; type 1 protrait
            picType: 1,
            topic: "data"
        }
    },
    uploadIdcards: {
        apiurl: apiserver + "/api/user/uploadidcards",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.4",
                patientToken: null
            },
            idCards: [{
                //url 为图片url
                url: "",
                preUrl: "",
                name: "zigezheng",
                // picType 1为资格证 2 为执业证
                picType: 1
            }],
            name: "laoyu",
            // 性别2 为男 1为女
            gender: 1,
            //医院
            hospital: "yanfa",
            // 科室
            department: 1,
            // 0 未选择 1 住院医师 2 主治医师 3 副主任医师 4主任医师
            title: 1,
            mail: "",
            departmentStr: "",
            titleStr: ""
        }
    },
    uploadIdcardsTwo: {
      apiurl: apiserver + "/api/user/uploadidcards",
      postData: {
          head: {
              auth: "",
              auth2: "",
              cid: "861010035174520",
              cver: "3.4",
              patientToken: null
          },
          idCards: [{
              //url 为图片url
              url: "",
              preUrl: "",
              name: "",
              // picType 1为资格证 2 为执业证
              picType: 0
          }],
          name: "laoyu",
          // 性别2 为男 1为女
          gender: 1,
          //医院
          hospital: "yanfa",
          // 科室
          department: 1,
          // 0 未选择 1 住院医师 2 主治医师 3 副主任医师 4主任医师
          title: 1,
          // mail: "",
          departmentStr: "",
          titleStr: ""
      }
  },
    uploadAvatar: {
        apiurl: apiserver + "/api/user/uploadheadportrait",
        postData: {
            head: {
                auth: "",
                auth2: "L1taWMa4lyvedQi1M6kSTQ==",
                patientToken: "oyZx_wr0AElX-MvQ6MfaRzboBLKo",
                cid: "123"
            },
            userType: 1,
            picData: "Portrait:data/1495101143889"
        }
    },
    checkCode: {
        apiurl: apiserver + "/api/user/registeruser",
        postData: {
            head: {
                cid: "861010035174520",
                cver: "3.5"
            },
            actionType: 4,
            mobile: "",
            verifyCode: ""
        }
    },
    getreadhistory: {
        apiurl: apiserver + "/api/doc/getreadhistory",
        postData: {
            head: {
                cid: "19364DBE-FA96-4801-9B23-09C4F9788F7B",
                cver: "2.2",
                sid: "Model:iPhone---Version:10.1",
                extensions: [{
                    name: "platform",
                    value: "iOS"
                }],
                auth: "",
                auth2: "YMp/hofsLd4lODcEb2xG6g=="
            },
            actionType: 1,
            filter: {
                pageIdx: 0,
                pageSize: 10
            }
        }
    },
    sendCode: {
        apiurl: apiserver + "/api/user/sendverifycode",
        postData: {
            actionType: 3,
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.4",
                extensions: [{
                        name: "platform",
                        value: "Android"
                    },
                    {
                        name: "channel",
                        value: "baidu"
                    },
                    {
                        name: "networkType",
                        value: "WIFI"
                    },
                    {
                        name: "phoneType",
                        value: "HUAWEI MLA-AL00"
                    },
                    {
                        name: "phoneVersion",
                        value: "7.0"
                    }
                ]
            },
            mobile: "",
            path: "/api/user/sendverifycode",
            pictureCode: "",
            token: ""
        }
    },
    getCollectDoc: {
        apiurl: apiserver + "/api/doc/getdocumentlist",
        postData: {
            head: {
                auth: "",
                auth2: "PiVZKyPg1/gRUUdHx/Aemg==",
                cid: "BEA79E4C-A2F3-49C3-AEEE-BD687E088FF7",
                cver: "3.4",
                sid: "Model:iPhone---Version:10.2.1",
                extensions: [{
                        name: "platform",
                        value: "iOS"
                    },
                    {
                        name: "phoneType",
                        value: "iPhone 6s Plus"
                    },
                    {
                        name: "phoneVersion",
                        value: "10.2"
                    }
                ],
                patientToken: null
            },
            filters: [{
                filterGroupId: 3,
                name: null,
                items: [{
                    filterId: 0,
                    value: null,
                    type: 0
                }]
            }],
            sort: {
                pageIdx: 0,
                pageSize: 10,
                startTime: 1495183035,
                orderBy: 0,
                direction: 0
            },
            eventId: 0,
            enterpriseId: 0,
            gethistory: 0
        }
    },
    getCollectSubject: {
        apiurl: apiserver + "/api/doc/eventlist",
        postData: {
            head: {
                auth: "",
                auth2: "PiVZKyPg1/gRUUdHx/Aemg==",
                cid: "BEA79E4C-A2F3-49C3-AEEE-BD687E088FF7",
                cver: "3.4",
                sid: "Model:iPhone---Version:10.2.1",
                extensions: [{
                        name: "platform",
                        value: "iOS"
                    },
                    {
                        name: "phoneType",
                        value: "iPhone 6s Plus"
                    },
                    {
                        name: "phoneVersion",
                        value: "10.2"
                    }
                ],
                patientToken: null
            },
            actionType: 4,
            channelId: null,
            filter: {
                pageSize: 10,
                pageIdx: 0
            }
        }
    },
    getCollectFile: {
        apiurl: apiserver + "/api/doc/attachmentlist",
        postData: {
            head: {
                auth: "",
                auth2: "PiVZKyPg1/gRUUdHx/Aemg==",
                cid: "BEA79E4C-A2F3-49C3-AEEE-BD687E088FF7",
                cver: "3.4",
                sid: "Model:iPhone---Version:10.2.1",
                extensions: [{
                        name: "platform",
                        value: "iOS"
                    },
                    {
                        name: "phoneType",
                        value: "iPhone 6s Plus"
                    },
                    {
                        name: "phoneVersion",
                        value: "10.2"
                    }
                ],
                patientToken: null
            },
            actionType: 4,
            channelId: null,
            filter: {
                pageSize: 10,
                pageIdx: 0
            }
        }
    },
    getMyComment: {
        apiurl: apiserver + "/api/comment/commentlist",
        postData: {
            commentFilter: {
                pageIdx: 0,
                pageSize: 10,
                queryTime: 0,
                queryType: 4
            },
            doctorId: 0,
            head: {
                auth: "",
                auth2: "EMidGFv7b921XU60no2w+Q==",
                cid: "354782065344066",
                cver: "3.4",
                extensions: [{
                        name: "platform",
                        value: "Android"
                    },
                    {
                        name: "channel",
                        value: "baidu"
                    },
                    {
                        name: "netWork",
                        value: "wifi"
                    },
                    {
                        name: "phoneType",
                        value: "SM-N9108V"
                    },
                    {
                        name: "phoneVersion",
                        value: "6.0.1"
                    }
                ]
            },
            listType: 2,
            path: "/api/comment/commentlist"
        }
    },
    userfeedback: {
        apiurl: apiserver + "/api/pub/userfeedback",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.4"
            },
            advice: "用户建议",
            userName: "",
            phone: "",
            email: "",
            urls: []
        }
    },
    //thirdPartyAuth2 unionID
    //thirdPartyAuth openid
    // 带auth
    wxBind: {
        apiurl: apiserver + "/api/user/registeruser",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.5"
            },
            actionType: 9,
            thirdPartyAuth: "",
            thirdPartyHeadPic: "",
            thirdPartType: 1,
            thirdPartyAuth2: "",
            mobile: '',
            verifyCode: 123456
        }
    },
    //不带auth 新用户注册  8:微信与新注册用户绑定
    wxBind2: {
        apiurl: apiserver + "/api/user/registeruser",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.5"
            },
            name: "",
            actionType: 8,
            thirdPartyAuth: "",
            thirdPartyHeadPic: "",
            thirdPartType: 1,
            thirdPartyAuth2: "",
            mobile: '',
            verifyCode: 123456
        }
    },
    //快速登录
    RapidEnrollment: {
        apiurl: apiserver + "/api/user/registeruser",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.5"
            },
            name: "",
            actionType: 5,
            mobile: '',
            verifyCode: 123456
        }
    },
    /**
       *     [v2.0.2]8:微信与新注册用户绑定
       [v2.0.2]9:微信与已存在用户绑定
       */
    wxLogin: {
        apiurl: apiserver + "/api/user/ifauthorized2",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.4"
            },
            thirdPartAuth: "",
            thirdPartAuth2: "",
            type: 7
        }
    },
    hasWxbind: {
        apiurl: apiserver + "/api/user/ifauthorized2",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.5"
            },
            type: 7
        }
    },
    unbindWx: {
        apiurl: apiserver + "/api/user/unbindWechat",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.5"
            }
        }
    },
    removeAttachment: {
        apiurl: apiserver + "/api/doc/collectattachment",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.2"
            },
            attachmentId: 1,
            actionType: 2
        }
    },
    getStudyInfo: {
        apiurl: apiserver + "/api/user/getstudyinfo",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.2"
            }
        }
    },
    starColumn: {
        apiurl: apiserver + "/api/pub/setuserconfig",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.2"
            },
            Columnists: [{
                ID: 0,
                isSubscribe: 0
            }]
        }
    },
    getUserConfig: {
        apiurl: apiserver + "/api/pub/getuserconfig",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.2"
            },
            actionType: 1
        }
    },
    setUserConfig: {
        apiurl: apiserver + "/api/pub/setuserconfig",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.2"
            },
            channels: [{
                    channelId: 1,
                    order: 1
                },
                {
                    channelId: 2,
                    order: 3
                }
            ],
            Columnists: [{
                    ID: 1,
                    isSubscribe: 0
                },
                {
                    ID: 2,
                    isSubscribe: 1
                }
            ]
        }
    },
    getqiniuUrl: {
        apiurl: apiserver + "/api/pub/getqiniupicurl",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.2"
            },
            picHeight: 400,
            picKey: "Portrait:data/1495010807063",
            picWidth: 400
        }
    },
    getUserAuthInfo: {
        apiurl: apiserver + "/api/user/downloadidcards",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "3.2"
            }
        }
    },
    getCompanyList: {
        apiurl: apiserver + "/api/pub/getlabelgrouplist",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "5.0"
            },
            groupId: [
                23
            ]
        }
    },
  checkInfoComplete: {
      apiurl: apiserver + "/api/user/checkInfoComplete",
      postData: {
        head: {
          auth: "",
          auth2: "",
          cid: "861010035174520",
          cver: "7.5"
        },
      }
    },
    getdiagram: {
        apiurl: apiserver + "/api/exam/getdiagram",
        postData: {
            patientId: 3480,
            filter: {
                startTime: Math.floor(new Date().getTime() / 1000 - 7 * 24 * 60 * 60),
                endTime: Math.floor(new Date().getTime() / 1000)
            },
            indexName: "LCSS_Patient",
            paperName: "FACT肿瘤治疗的功能性评价heheh",
            head: {
                cid: "CCE64720-E67E-4FBB-AA15-1005FB967F60",
                cver: "1.4",
                sid: "Model:iPhone---Version:9.3",
                extensions: [{
                    name: "platform",
                    value: "iOS"
                }],
                auth: "BmulacBCmYzdC8m/7Eh8+VYl73e1BD1WgZt9SeD/AZ0=",
                auth2: "pEeS65TtdOjTW5zypP8/oA=="
            }
        }
    },
    getdiagramfilter: {
        apiurl: apiserver + "/api/exam/getdiagramfilter",
        postData: {
            patientId: 3480,
            head: {
                cid: "CCE64720-E67E-4FBB-AA15-1005FB967F60",
                cver: "1.4",
                sid: "Model:iPhone---Version:9.3",
                extensions: [{
                    name: "platform",
                    value: "iOS"
                }],
                auth: "BmulacBCmYzdC8m/7Eh8+VYl73e1BD1WgZt9SeD/AZ0=",
                auth2: "pEeS65TtdOjTW5zypP8/oA=="
            }
        }
    },
    getUserInfoDiff: {
        apiurl: apiserver + "/api/user/v3/getUserInfoDiff",
        postData: {
            head: {
                auth: "",
                auth2: "",
                cid: "861010035174520",
                cver: "9.5"
            },
            pro:'1'

        }
    },
    /**
     * 获取openid
     *
     */
    getOpenid: {
      apiurl: apiserver + "/api/user/ifauthorized2",
      postData: {
        head: {
          auth: "",
          cid: "",
          cver: "9.5"
        },
        type: 7 //7:微信公众号
      }
    },

    /**
     * 更新openid
     *
     */
    updateOpenid: {
      apiurl: apiserver + "/api/user/updateWeChatBind",
      postData: {
        head: {
          auth: "",
          cid: "",
          cver: "9.5"
        },
        thirdPartType: 7, // 1:app的openid    7：学术大使的openid
        openId: ''
      }
    },
};
